import { reactive } from 'vue';

// Одна форма заявки на весь лендинг. Кнопки секций только открывают её и
// говорят, с какого тарифа или услуги человек пришёл; отправка — в ApplicationForm.vue.
// package_name = null — человек пришёл с общей кнопки и ещё ничего не выбрал.
export const application = reactive({
  is_open: false,
  package_name: null,
});

export function openApplication({ package_name = null } = {}) {
  application.package_name = package_name;
  application.is_open = true;
}

export function closeApplication() {
  application.is_open = false;
}
